import '../../css/modules/accordion.css';

import gsap, { Power2 } from 'gsap';
// @ts-ignore
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
export class Accordion {


  private _open_container_element: HTMLElement;
  private _open_content_element: HTMLElement;

  constructor() {

    gsap.registerPlugin( ScrollToPlugin );

    const elements: NodeListOf<HTMLElement> = document.querySelectorAll( '.c-accordion' );
    for ( let i: number = 0; i < elements.length; i++ ) this.setup( elements[ i ] );

  }


  private setup( element: HTMLElement ) {

    const items: NodeListOf<HTMLElement> = element.querySelectorAll( '.c-accordion__item' );
    for ( let i: number = 0; i < items.length; i++ ) {

      const container_element: HTMLElement = items[ i ];
      const toggle_element: HTMLElement = items[ i ].querySelector( '.c-accordion__item__toggle' );
      const content_element: HTMLElement = items[ i ].querySelector( '.c-accordion__item__content' );
      toggle_element.addEventListener( 'click', ( event: Event ) => this.handleToggleClicked( event, container_element, content_element ) );
      
      if ( i === 0 ) this.openItem( container_element, content_element );
    
    }

  }


  private handleToggleClicked( event: Event, container_element: HTMLElement, content_element: HTMLElement ) {

    event.preventDefault();

    if ( content_element ) {
      
      if ( content_element.style.maxHeight ) {
        
        this.closeItem( container_element, content_element );
        
      } else {
        
        this.openItem( container_element, content_element );

        // The accordion toggle animation is 350ms (defined in accordion.css)
        // Have to wait for that animation to finish before we can scroll
        setTimeout(() => {
          gsap.to( window, { duration: .4, scrollTo: { y: container_element, offset: 200 } } );
        }, 350);
        
      }

    }

    return false;

  }


  private openItem( container_element: HTMLElement, content_element: HTMLElement ) {
    
    if ( this._open_container_element && this._open_content_element ) {
      
      this.closeItem( this._open_container_element, this._open_content_element );

    }

    this._open_container_element = container_element;
    this._open_content_element = content_element;
    
    content_element.style.maxHeight = content_element.scrollHeight + "px";
    container_element.classList.add( 's-toggled' );

  }


  private closeItem( container_element: HTMLElement, content_element: HTMLElement ) {

    content_element.style.maxHeight = null;
    container_element.classList.remove( 's-toggled' );

  }

}